export type GenesProps = {
  id: string | undefined
  name: string

}

export class Genes {
  private readonly _id: string | undefined
  _name: string

  constructor(p: GenesProps) {
    this._id = p.id
    this._name = p.name

  }

  get id(): string | undefined {
    return this._id
  }

  get name(): string {
    return this._name
  }

  set name(value: string) {
    this._name = value
  }
}

export interface GenesQuery {
  id: string
  ids: string[]
  name: string
  names: string[]
}
